
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/wiki-page-revisions/jst/WikiPageRevisions';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    <div class=\"revision-nav-buttons\">\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.FETCH_PREV), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.FETCH_NEXT), {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n  ";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <a class=\"prev-button\"><i class=\"icon-mini-arrow-left\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_revisions")
  },data:data},helper ? helper.call(depth0, "previous_bd2ac015", "Previous", options) : helperMissing.call(depth0, "t", "previous_bd2ac015", "Previous", options)))
    + "</a>\n      ";
  return buffer;
  }

function program4(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <a class=\"next-button\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_revisions")
  },data:data},helper ? helper.call(depth0, "next_40e12421", "Next", options) : helperMissing.call(depth0, "t", "next_40e12421", "Next", options)))
    + " <i class=\"icon-mini-arrow-right\"></i></a>\n      ";
  return buffer;
  }

  buffer += "<aside>\n  <div class=\"revision-history\">\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_revisions")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_revisions.revision_history", "Revision History", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_revisions.revision_history", "Revision History", options)))
    + "\n    <a href=\"#\" class=\"close-button\"><i class=\"icon-x\"></i></a>\n  </div>\n  <ul class=\"collectionViewItems revisions-list\">\n  </ul>\n  ";
  stack1 = (helper = helpers.ifAny || (depth0 && depth0.ifAny),options={hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.FETCH_PREV), ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.FETCH_NEXT), options) : helperMissing.call(depth0, "ifAny", ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.FETCH_PREV), ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.FETCH_NEXT), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</aside>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  